/**
 * UUID utilities using the native Web Crypto API.
 * crypto.randomUUID() is available in all modern browsers (Chrome 92+, Firefox 95+, Safari 15.4+) and Node 14.17+.
 * Replaces the 'uuid' npm package for browser-compatible code.
 *
 * Note: this uses the Web Crypto API (global `crypto`), NOT Node.js `require('crypto')`.
 * Node's crypto.randomBytes() is server-only and must not be used in browser bundles.
 * For server-side nonce generation (e.g. CSP middleware), see src/server/csp.js.
 */

export const NIL = '00000000-0000-0000-0000-000000000000';

export function uuid() {
	return crypto.randomUUID();
}
